import { render, staticRenderFns } from "./CheckboxListField.vue?vue&type=template&id=16808602"
import script from "./CheckboxListField.vue?vue&type=script&lang=js"
export * from "./CheckboxListField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports